import { createContext } from 'react'

export type CallStatus =
  | 'callback'
  | 'loading'
  | 'waiting'
  | 'phoneRings'
  | 'calling'

type CallStatusContextValue = {
  status: CallStatus
  setStatus: (status: CallStatus) => void
}
export const CallStatusContext = createContext<CallStatusContextValue>({
  status: 'loading',
  setStatus: () => {},
})
